var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_more_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 12C7.92969 13.1046 7.03426 14 5.92969 14C4.82512 14 3.92969 13.1046 3.92969 12C3.92969 10.8954 4.82512 10 5.92969 10C7.03426 10 7.92969 10.8954 7.92969 12Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9297 12C14.9297 13.1046 14.0343 14 12.9297 14C11.8251 14 10.9297 13.1046 10.9297 12C10.9297 10.8954 11.8251 10 12.9297 10C14.0343 10 14.9297 10.8954 14.9297 12Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9297 12C21.9297 13.1046 21.0343 14 19.9297 14C18.8251 14 17.9297 13.1046 17.9297 12C17.9297 10.8954 18.8251 10 19.9297 10C21.0343 10 21.9297 10.8954 21.9297 12Z",
    fill: "#7F7F7F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.0b84d333bf494aaaf77d8bd74e6c96f3.svg";
export { ForwardRef as ReactComponent };